import { memo } from 'react'
import { ReactComponent as PlusIcon } from '../../assets/icons/add-item.svg'

const VNPlusButton = ({ className, onClick = () => {} }) => {
  return <PlusIcon className={className} onClick={onClick} />
}
export default memo(VNPlusButton)
